/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_InvalidInputs */

const en_us2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That email looks incomplete. Check it and try again.`)
};

const pt_br2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse e-mail parece incompleto. Confira e tente de novo.`)
};

const es_419_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese email parece incompleto. Revísalo e inténtalo de nuevo.`)
};

const pt_pt2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse e-mail parece incompleto. Verifica-o e tenta outra vez.`)
};

const fr_fr2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet e-mail semble incomplet. Vérifie-le et réessaie.`)
};

const de_de2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail sieht unvollständig aus. Prüf sie und versuch es noch mal.`)
};

const it_it2_auth_email_invalid = /** @type {(inputs: Auth_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa email sembra incompleta. Controllala e riprova.`)
};

/**
* | output |
* | --- |
* | "That email looks incomplete. Check it and try again." |
*
* @param {Auth_Email_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_invalid = /** @type {((inputs?: Auth_Email_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_invalid(inputs)
	if (locale === "es-419") return es_419_auth_email_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_invalid(inputs)
	if (locale === "de-DE") return de_de2_auth_email_invalid(inputs)
	if (locale === "it-IT") return it_it2_auth_email_invalid(inputs)
	return en_us2_auth_email_invalid(inputs)
});
export { auth_email_invalid as "auth.email_invalid" }